module.exports = __webpack_public_path__ + "static/media/g-5-b.2ce1b613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-5-b.jpg
// module id = 1141
// module chunks = 33